<template>
  <div id="servatur"/>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import { nextTick } from 'vue'
  import constants from '@/constants'
  import utils from '@/services/utils'
  export default {
    props: {
      /*
      data: {
        type: Object,
        required: true,
        default: null
      },*/
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      }
    },
    mounted () {
      let rs = document.createElement('script')
      rs.setAttribute('src', 'https://widget.simplybook.it/v2/widget/widget.js')
      document.head.appendChild(rs)  
      setTimeout(() => {
        console.log("1 Segundo esperado")
        var widget = new SimplybookWidget({"container_id": "servatur","widget_type":"iframe","url":"https:\/\/wbgc.simplybook.it","theme":"classic","theme_settings":{"timeline_hide_unavailable":"1","hide_past_days":"0","timeline_show_end_time":"0","timeline_modern_display":"as_slots","sb_base_color":"#6ec1e4","display_item_mode":"list","body_bg_color":"#fdfdfd","sb_review_image":"","sb_company_label_color":"#ffffff","hide_img_mode":"1","sb_busy":"#dad2ce","sb_available":"#e86de1"},"timeline":"modern","datepicker":"top_calendar","is_rtl":false,"app_config":{"allow_switch_to_ada":0,"predefined":[]}})
      }, 1000)

      /*
      container_id
      const scriptServatur = document.getElementsByClassName('scriptservatur')[0]
      //const aux2 = document.getElementsByClassName('mainservatur2')[0]
      var newScript = document.createElement('script')
      var inlineScript = document.createTextNode(`var widget = new SimplybookWidget({"container_id": "servatur",widget_type":"iframe","url":"https:\/\/wbgc.simplybook.it","theme":"classic","theme_settings":{"timeline_hide_unavailable":"1","hide_past_days":"0","timeline_show_end_time":"0","timeline_modern_display":"as_slots","sb_base_color":"#6ec1e4","display_item_mode":"list","body_bg_color":"#fdfdfd","sb_review_image":"","sb_company_label_color":"#ffffff","hide_img_mode":"1","sb_busy":"#dad2ce","sb_available":"#e86de1"},"timeline":"modern","datepicker":"top_calendar","is_rtl":false,"app_config":{"allow_switch_to_ada":0,"predefined":[]}})`)
  
      newScript.appendChild(inlineScript)
      //aux.appendChild(rs)
      scriptServatur.appendChild(newScript)
      
      console.log('dddd')
      */
    }
  }
</script>
